import toString from 'lodash/toString';

import countryiso from '../../constants/countryiso.json';

import callApi from '../../util/apiCaller';
import eventCallApi from '../../util/apiEventCaller';
import venueCallApi from '../../util/apiVenueCaller';

import { userNotify } from '../../modules/components/Toasts/ToastAdd';
import occasionList from '../../constants/occasionList.json';
import { gtmUserIdTrigger } from '../../util/gtmTrigger';
import { fetchEventAndBundle } from './EventActions';

const GOOGLE_MAP_KEY = '';

// utility
export const LOAD_CITY_LIST = 'LOAD_CITY_LIST';
export const PAGE_NOT_FOUND = 'PAGE_NOT_FOUND';
export const PAGE_REDIRECT = 'PAGE_REDIRECT';

// register
export const REQUEST_REGISTER = 'REQUEST_REGISTER';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';
export const RESET_REGISTER = 'RESET_REGISTER';
export const REGISTER_PAUSE = 'REGISTER_PAUSE';
export const REGISTER_SUCCESS_MODAL = 'REGISTER_SUCCESS_MODAL';

// Export Constants
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const REQUEST_OTP_LOGIN = 'REQUEST_OTP_LOGIN';
export const REQUEST_OTP_FAILURE = 'REQUEST_OTP_FAILURE';
export const REQUEST_OTP_SUCCESS = 'REQUEST_OTP_SUCCESS';
export const VERIFYING_OTP = 'VERIFYING_OTP';
export const LOGIN_OTP_SUCCESS = 'LOGIN_OTP_SUCCESS';
export const LOGIN_OTP_FAILURE = 'LOGIN_OTP_FAILURE';
export const REQUEST_OTP_FAILURE_MOBILE = 'REQUEST_OTP_FAILURE_MOBILE';
export const REQUEST_OTP_SUCCESS_MOBILE = 'REQUEST_OTP_SUCCESS_MOBILE';

export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const REQUEST_CHECK_TOKEN = 'REQUEST_CHECK_TOKEN';
export const TOKEN_VALID = 'TOKEN_VALID';
export const TOKEN_INVALID = 'TOKEN_INVALID';

export const EDIT_USER_INFO = 'EDIT_USER_INFO';
export const EDITING_USER_INFO = 'EDITING_USER_INFO';
export const CLOSE_EDIT_USER_INFO = 'CLOSE_EDIT_USER_INFO';
export const UPDATE_USER_INFO_STATE = 'UPDATE_USER_INFO_STATE';

export const CONTACT_SUBMITTING_DATA = 'CONTACT_SUBMITTING_DATA';

export const LOADING_CAREERS_PAGE = 'LOADING_CAREERS_PAGE';
export const LOAD_CAREERS_PAGE = 'LOAD_CAREERS_PAGE';

export const SET_LOGIN_OTP_FAILURE = 'SET_LOGIN_OTP_FAILURE';
export const RESET_LOGIN_OTP_FAILURE = 'RESET_LOGIN_OTP_FAILURE';

export const LOGIN_SUCCESS_MODAL = 'LOGIN_SUCCESS_MODAL';
export const RESEND_LOGIN_OTP = 'RESEND_LOGIN_OTP';

export const ADDING_USER_LOCATION = 'ADDING_USER_LOCATION';

// Pagedata
export const SET_CITY = 'SET_CITY';
export const FETCHING_PAGEDATA = 'FETCHING_PAGEDATA';
export const FETCH_PAGEDATA = 'FETCH_PAGEDATA';
export const SET_HOME_PAGE_FOOTER = 'SET_HOME_PAGE_FOOTER';
export const SET_NETWORK_STATUS = 'SET_NETWORK_STATUS';
export const BACK_BUTTON_VISIBILITY_STATUS = 'BACK_BUTTON_VISIBILITY_STATUS';

// corporate page
export const TOGGLE_CORPORATE_PAGE_HEADER = 'TOGGLE_CORPORATE_PAGE_HEADER';
export const TOGGLE_LEAD_SUBMITTING = 'TOGGLE_LEAD_SUBMITTING';
export const CORPORATE_USER_REGISTER_STATUS = 'CORPORATE_USER_REGISTER_STATUS';
export const LOGIN_REDIRECTION_URL = 'LOGIN_REDIRECTION_URL';

export const SET_AUTH_VIEW = 'SET_AUTH_VIEW';
export const IS_ADS_BANNER_VISIBLE = 'IS_ADS_BANNER_VISIBLE'
// export const SET_OTP_ERROR = 'SET_OTP_ERROR';
// export const SET_MOBILE_ERROR = 'SET_MOBILE_ERROR';

// Export Actions

export function showAdsBanner(val) {
    return {
        type: IS_ADS_BANNER_VISIBLE,
        isAdsBannerVisible: val,
    };
}

export function setLoginSignUPRedirectionUrl(loginRedirectionUrl) {
    return {
        type: LOGIN_REDIRECTION_URL,
        loginRedirectionUrl: loginRedirectionUrl,
    };
}

export function navigateTo(redirectUrl) {
  let url = redirectUrl;
    if (url && url === '') {
        // router.push('');
    } else {
        // router.push(`${url}`);
    }
}

export function corporateUserRegisterStatus(val) {
    return {
        type: CORPORATE_USER_REGISTER_STATUS,
        isCorporateUserRegistered: !!val,
    };
}

export function requestingRegister() {
    return {
        type: REQUEST_REGISTER,
        isRegistering: true,
    };
}

export function registerSuccess() {
    return {
        type: REGISTER_SUCCESS,
        isRegistering: false,
        isRegisterOTPSent: true,
    };
}

export function registerFailure() {
    return {
        type: REGISTER_FAILURE,
        isRegistering: false,
        isRegisterOTPSent: false,
    };
}

export function resetRegisterPage() {
    return (dispatch) => {
        dispatch({
            type: RESET_REGISTER,
            isRegistering: false,
            isRegisterOTPSent: false,
        });
    };
}

export function sendContactUsSubmittingData(val) {
    return {
        type: CONTACT_SUBMITTING_DATA,
        isSubmitting: !!val,
    };
}




export function contactusSubmittingData(data) {
    return (dispatch) => {
        dispatch(sendContactUsSubmittingData(true));
        return callApi('utility/contactus-page', 'POST', data).then((res) => {
            if (res.status === 'Success') {
                userNotify('We Will Get Back To You Soon', 'success');
                dispatch(sendContactUsSubmittingData(false));
            } else {
                dispatch(sendContactUsSubmittingData(false));
            }
        });
    };
}

export function showLoadingJobs() {
    return {
        type: LOADING_CAREERS_PAGE,
        isFetchingJobs: true,
    };
}

export function loadJobs(jobs) {
    return {
        type: LOAD_CAREERS_PAGE,
        isFetchingJobs: false,
        jobs,
    };
}

export function fetchActiveJobs() {
    return (dispatch) => {
        dispatch(showLoadingJobs());
        return callApi('jobs/list/open', 'get').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadJobs(res.data.jobs));
            }
        });
    };
}

export function submitContactDetails(data) {
    return (dispatch) => {
        dispatch(sendContactUsSubmittingData(true));
        return callApi('utility/email-contact', 'POST', data).then((res) => {
            if (res.status === 'Success') {
                dispatch(sendContactUsSubmittingData(false));
            } else {
                // dispatch(userNotify('Server failed, Please try again', 'error'));
                dispatch(sendContactUsSubmittingData(false));
            }
        });
    };
}

export function submitListYourBusiness(data) {
    return (dispatch) => {
        dispatch(sendContactUsSubmittingData(true));
        return callApi('utility/list-business', 'POST', {
            listbiz: data,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(sendContactUsSubmittingData(false));
                // dispatch(userNotify('We will shortly get back with you.', 'error'));
            } else {
                // dispatch(userNotify('Server failed, Please try again', 'error'));
                dispatch(sendContactUsSubmittingData(false));
            }
        });
    };
}

export function showFetchingPagedata() {
    return {
        type: FETCHING_PAGEDATA,
        isFetchingPagedata: true,
    };
}

export function loadPagedata(data) {
    const arr = countryiso;
    const result = new Map(arr.map((i) => [i.Name, i.Code]));
    return {
        type: FETCH_PAGEDATA,
        isFetchingPagedata: false,
        pagedata: data.pagedata,
        nation: data.nation,
        countryCodeDict: result,
    };
}

export function fetchPagedata(cityslug) {
    const NOT_REQUIRED_VALUES = [null, undefined, 'undefined', ''];
    if (NOT_REQUIRED_VALUES.includes(cityslug)) {
        cityslug = 'gurgaon';
    }
    return (dispatch) => {
        dispatch(showFetchingPagedata());
        return venueCallApi(`utility/home/${toString(cityslug)}/pagedata`, 'get').then((res) => {
            if (res.status === 'Success') {
                res.data.pagedata.occasionList = occasionList;
                dispatch(loadPagedata(res.data));
                // dispatch(loadLeadParams(res.data.pagedata.cityList, res.data.pagedata.occasionList));
            } else {
                // userNotify('Failed to load page, please try again', 'error');
            }
        });
    };
}

export function consumeMagicToken(mtoken, router) {
    return (dispatch) => {
        return callApi(`auth/consume-magic-token?mtoken=${mtoken}`, 'post', {}).then((res) => {
            const { user, message } = res;
            if (user) {
                if (!user.ok) {
                    dispatch(loginFailure(message));
                    userNotify(message, 'danger');
                    // return Promise.reject(message);
                } else {
                    localStorage.setItem('token', user.token);
                    localStorage.setItem('idToken', user.idToken);
                    const event = user.event;
                    console.log(router.query.re==0,"rerererer")
                    if(router.query.re!=0){
                        router.push(`/events/proposal?etid=${event._id}`);
                    }else{
                        dispatch(fetchEventAndBundle(event._id));
                    }
                   
                    dispatch(loginSuccess(user));
                }
            } else {
                dispatch(loginFailure(message));
                userNotify(message, 'danger');
                // return Promise.reject(message);
            }
        });
    };
}

export function setCity(cityslug) {
    return (dispatch) => {
        dispatch({
            type: SET_CITY,
            selectedCity: cityslug,
        });
    };
}

export function setPageNotFound(val) {
    return (dispatch) => {
        dispatch({
            type: PAGE_NOT_FOUND,
            isPageNotFound: val,
        });
    };
}

export function setPageRedirect(data) {
    return (dispatch) => {
        dispatch({
            type: PAGE_REDIRECT,
            isPageRedirect: data.isPageRedirect,
            redirectStatus: data.redirectStatus,
            redirectUrl: data.redirectUrl,
        });
    };
}

export function loadCityList(data) {
    return {
        type: LOAD_CITY_LIST,
        cities: data.cities,
        occasions: data.occasions,
        budget_range: data.budget_range,
        guest_range: data.guest_range,
        package_details: data.package_details,
    };
}

export function fetchCityList() {
    return (dispatch) => {
        dispatch(showFetchingPagedata());
        return callApi('v1/cities/citylist', 'get').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadCityList(res.data));
            } else {
                //  userNotify('Failed to load page, please try again', 'error');
            }
        });
    };
}

export function setPageFooter(val) {
    return (dispatch) => {
        dispatch({
            type: SET_HOME_PAGE_FOOTER,
            isFooterBelowVisible: val,
        });
    };
}

export function toggleCorporatePageHeader(val) {
    return {
        type: TOGGLE_CORPORATE_PAGE_HEADER,
        isCorporateHeaderVisible: !!val,
    };
}

export function showCorporateLeadSubmit(val) {
    return {
        type: TOGGLE_LEAD_SUBMITTING,
        isCorporateLeadSubmitting: !!val,
    };
}

export function submitCorporateLead(lead) {
    return (dispatch) => {
        dispatch(showCorporateLeadSubmit(true));
        return callApi('corporate/lead', 'post', {
            corporatelead: lead,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(showCorporateLeadSubmit(false));
                dispatch(corporateUserRegisterStatus(true));
                userNotify('We will be in touch with you soon.', 'success');
            } else {
                dispatch(showCorporateLeadSubmit(false));
                // userNotify('Failed to load page, please try again', 'error');
            }
        });
    };
}

// Export Actions

// export function setMobileError(mobileError) {
//   return {
//     type: SET_MOBILE_ERROR,
//     mobileError,
//   };
// }

// export function setOTPError(otpError) {
//   return {
//     type: SET_OTP_ERROR,
//     otpError,
//   };
// }

export function setAuthView(authView) {
    return {
        type: SET_AUTH_VIEW,
        authView,
    };
}

export function setBackButtonVisibleState(status) {
    return {
        type: BACK_BUTTON_VISIBILITY_STATUS,
        isBackButtonVisible: status,
    };
}

export function setNetworkStatus(status) {
    return {
        type: SET_NETWORK_STATUS,
        isOnline: status,
    };
}

export function requestingLogin(refurl) {
    return {
        type: REQUEST_LOGIN,
        _refurl: refurl,
        isFetching: true,
    };
}

export function loginSuccess(user) {
    return {
        type: LOGIN_SUCCESS,
        isFetching: false,
        isAuthenticated: true,
        token: user.token,
        user: user.data,
    };
}

export function loginFailure(message) {
    return {
        type: LOGIN_FAILURE,
        isFetching: false,
        isAuthenticated: false,
        message,
    };
}

function requestLogout() {
    return {
        type: REQUEST_LOGOUT,
        isFetching: false,
        isAuthenticated: false,
        isVerifying: false,
        isLoginOtpFailure: false,
        token: '',
        user: {},
    };
}

export function logoutUser() {
    return (dispatch) => {
        localStorage.removeItem('token');
        dispatch(requestLogout());
    };
}

export function requestCheckToken() {
    return {
        type: REQUEST_CHECK_TOKEN,
        isFetching: true,
        isAuthenticated: false,
    };
}

export function tokenValid(user = {}) {
    return {
        type: TOKEN_VALID,
        isFetching: false,
        isAuthenticated: true,
        data: user,
    };
}

export function tokenInvalid() {
    return {
        type: TOKEN_INVALID,
        isFetching: false,
        isAuthenticated: false,
        data: {},
    };
}

export function checkToken(sToken) {
    return (dispatch) => {
        const token = typeof window === 'undefined' ? sToken : window.localStorage.getItem('token');
        if (!token) {
            return dispatch(tokenInvalid());
        } else {
            dispatch(requestCheckToken());
            return callApi('auth/verify', 'post', {
                token,
            }).then((res) => {
                const { user } = res;
                if (!user.ok) {
                    dispatch(tokenInvalid());
                    return Promise.reject();
                } else {
                    dispatch(tokenValid(user.data));
                    gtmUserIdTrigger(user.data._id);
                }
            });
        }
    };
}

export function loginUser(creds, url) {
    return (dispatch) => {
        dispatch(requestingLogin(url));
        return eventCallApi('v1/auth/login', 'post', creds, false, true).then((res) => {
            const { user, message } = res;
            if (user) {
                if (!user.ok) {
                    dispatch(loginFailure(message));
                    userNotify(message, 'danger');
                    return Promise.reject(message);
                } else {
                    localStorage.setItem('token', user.token);
                    dispatch(loginSuccess(user));
                }
            } else {
                dispatch(loginFailure(message));
                userNotify(message, 'danger');
                return Promise.reject(message);
            }
        });
    };
}

export function loginByGoogle(creds, url) {
    return (dispatch) => {
        dispatch(requestingLogin(url));
        return callApi('auth/google-login', 'post', creds).then((res) => {
            const { user, message } = res;
            if (!user.ok) {
                dispatch(loginFailure(message));
                userNotify(message, 'danger');
                return Promise.reject(message);
            } else {
                localStorage.setItem('token', user.token);
                dispatch(loginSuccess(user));
            }
        });
    };
}

export function loginByFacebook(creds, url) {
    return (dispatch) => {
        dispatch(requestingLogin(url));
        return callApi('auth/facebook-login', 'post', creds).then((res) => {
            const { user, message } = res;
            if (!user.ok) {
                dispatch(loginFailure(message));
                userNotify(message, 'danger');
                return Promise.reject(message);
            } else {
                localStorage.setItem('token', user.token);
                dispatch(loginSuccess(user));
            }
        });
    };
}

export function setRedirectURL(url) {
    if (url && url !== '') {
        // router.push(`/login?ref=${url}`);
    }
}

export function requestOtpLogin() {
    return {
        type: REQUEST_OTP_LOGIN,
        isRequestingOtp: true,
        isOTPSent: false,
    };
}
export function resendLoginOtp() {
    return {
        type: RESEND_LOGIN_OTP,
        resendingLoginOtp: true,
        isLoginOtpFailure: false,
        isOTPSent: false,
    };
}

export function processOTPRequestFail(message) {
    return {
        type: REQUEST_OTP_FAILURE,
        isRequestingOtp: false,
        resendingLoginOtp: false,
        isOTPSent: false,
        message,
    };
}

export function processOTPRequestSuccess(message) {
    return {
        type: REQUEST_OTP_SUCCESS,
        isRequestingOtp: false,
        resendingLoginOtp: false,
        isOTPSent: true,
        message,
    };
}

export function verifyingLoginOTP(val) {
    return {
        type: VERIFYING_OTP,
        isVerifying: val,
    };
}

export function loginOtpSuccess(user) {
    return {
        type: LOGIN_OTP_SUCCESS,
        isFetching: false,
        isAuthenticated: true,
        token: user.token,
        data: user.data,
        isRequestingOtp: false,
        resendingLoginOtp: false,
        isOTPSent: false,
        isVerifying: false,
        isOtpVerified: true,
    };
}

export function setLoginOtpFailure(isLoginOtpFailure) {
    return {
        type: SET_LOGIN_OTP_FAILURE,
        isLoginOtpFailure: isLoginOtpFailure,
    };
}

export function loginOtpFailure(message) {
    return {
        type: LOGIN_OTP_FAILURE,
        isFetching: false,
        isAuthenticated: false,
        message,
        isRequestingOtp: false,
        isLoginOtpFailure: true,
        isOTPSent: false,
        isVerifying: false,
    };
}

export function resetLoginOtpFailure() {
    return {
        type: RESET_LOGIN_OTP_FAILURE,
        isLoginOtpFailure: false,
    };
}

export function requestOTPLogin(creds, type, callback = null) {
    const updatedCreds = {
        ...creds,
        country_code: "91"
    };
    return (dispatch) => {
        if (type === 'resend-otp') {
            dispatch(resendLoginOtp());
        } else {
            dispatch(requestOtpLogin());
        }
        return eventCallApi('v1/auth/request-otp', 'post', updatedCreds, false, true).then((res) => {
            const { isOTPSent, message } = res.data;
            if (callback) {
                callback(null, isOTPSent);
            }
            if (isOTPSent) {
                // userNotify('OTP Sent Successfully', 'success')
                dispatch(processOTPRequestSuccess(message));
            } else {
                dispatch(processOTPRequestFail(message));
            }
        });
    };
}

export function requestOTPLoginMobile(creds, callback = null) {
    const updatedCreds = {
        ...creds,
        country_code: "91"
    };
    return (dispatch) => {
        dispatch(requestOtpLogin());
        return eventCallApi('v1/auth/request-otp', 'post', updatedCreds, false, true).then((res) => {
            const { isOTPSent, message } = res;
            if (callback) {
                callback(null, isOTPSent);
            }
            if (isOTPSent) {
                userNotify('Otp Sent Successfully', 'success');
                dispatch(processOTPRequestSuccessMobile(message));
            } else {
                dispatch(processOTPRequestFailMobile(message));
            }
        });
    };
}

export function processOTPRequestFailMobile(message) {
    return {
        type: REQUEST_OTP_FAILURE_MOBILE,
        isRequestingOtp: false,
        isOTPSent: false,
        message,
    };
}

export function processOTPRequestSuccessMobile(message) {
    return {
        type: REQUEST_OTP_SUCCESS_MOBILE,
        isRequestingOtp: false,
        isOTPSent: true,
        message,
    };
}

export function requestEmailOTPLogin(creds) {
    return (dispatch) => {
        dispatch(requestOtpLogin());
        return callApi('auth/request-email-otp', 'post', creds).then((res) => {
            const { isOTPSent, message } = res;
            if (isOTPSent) {
                dispatch(processOTPRequestSuccess(message));
            } else {
                dispatch(processOTPRequestFail(message));
            }
        });
    };
}

export function authenticateOTP(creds, type, callback = null) {
    const updatedCreds = {
        ...creds,
        country_code: "91"
    };
    return (dispatch) => {
        dispatch(verifyingLoginOTP(true));
        return eventCallApi('v1/auth/authenticate-otp', 'post', updatedCreds, false, true)
            .then((res) => {
                const { user, message, ok } = res.data;
                if (!ok) {
                    dispatch(loginOtpFailure(message));
                    userNotify(message, 'danger');
                    dispatch(setOTPError(true));
                    if (callback) {
                        callback(null, false);
                    }
                } else {
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('idToken', res.data.idToken);
                    gtmUserIdTrigger(user?._id);
                    dispatch(loginOtpSuccess(user));
                    if (type === 'login') {
                        setTimeout(() => {
                            dispatch(setLoginSuccessModal(true));
                        }, 1200);
                    } else if (type === 'signup') {
                        setTimeout(() => {
                            dispatch(setRegisterSuccessModal(true));
                        }, 1200);
                    }
                    dispatch(setAuthView('success'));
                    dispatch(fetchUserInfo(user?._id))
                    if (callback) {
                        callback(null, true);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
}

export function authenticateOTPMobile(creds, callback = null) {
    const updatedCreds = {
        ...creds,
        country_code: "91"
    };
    return (dispatch) => {
        dispatch(verifyingLoginOTP(true));
        return eventCallApi('v1/auth/authenticate-otp', 'post', updatedCreds, false, true).then((res) => {
            const { user, message, ok } = res.data;
            if (!ok) {
                dispatch(loginOtpFailure(message));
                if (callback) {
                    callback(null, false);
                }
                userNotify(message, 'danger');
            } else {
                localStorage.setItem('token', user.token);
                localStorage.setItem('idToken', user.idToken);
                gtmUserIdTrigger(user._id);
                dispatch(loginOtpSuccess(user));
                dispatch(fetchUserInfo(user?._id))
                if (callback) {
                    callback(null, true);
                }
            }
        });
    };
}

export function setLoginSuccessModal(val) {
    return {
        type: 'LOGIN_SUCCESS_MODAL',
        payload: val,
    };
}

export function authenticateEmailOTP(creds) {
    return (dispatch) => {
        dispatch(verifyingLoginOTP(true));
        return callApi('auth/authenticate-email-otp', 'post', creds).then((res) => {
            const { user, message } = res;
            if (!user.ok) {
                dispatch(loginOtpFailure(message));
                userNotify(message, 'danger');
                return Promise.reject(message);
            } else {
                localStorage.setItem('token', user.token);
                dispatch(loginOtpSuccess(user));
            }
        });
    };
}

export function editUserInfo() {
    return {
        type: EDIT_USER_INFO,
        isEditingUserInfo: true,
    };
}

export function closeUserInfo() {
    return {
        type: CLOSE_EDIT_USER_INFO,
        isEditingUserInfo: false,
        isSavingUserInfo: false,
    };
}

export function updateUserState(user) {
    return {
        type: UPDATE_USER_INFO_STATE,
        user,
    };
}

export function showProfileSavingLoader() {
    return {
        type: EDITING_USER_INFO,
        isSavingUserInfo: true,
    };
}

export function fetchUserInfo(id) {
    return (dispatch) => {
        return eventCallApi(`v1/auth/profile/user/${id}`, 'POST',{}, false, true)
            .then((res) => {
                if (res.status === 'Success') {
                    dispatch(updateUserState(res.data.user));
                }
            })
            .catch((err) => {});
    };
}

export function saveUserInfo(id, user) {
    return (dispatch) => {
        dispatch(showProfileSavingLoader());
        return eventCallApi(`v1/auth/profile/${id}/user-update`, 'POST', {
            user,
        },false, true).then((res) => {
            if (res.status === 'Success') {
                dispatch(updateUserState(res.data.user));
                dispatch(fetchUserInfo(id))
                dispatch(closeUserInfo());
            } else {
                userNotify('Failed To Update!', 'error');
                dispatch(closeUserInfo());
            }
        });
    };
}

export function discardOTPOnCloseModal() {
    return {
        type: REGISTER_PAUSE,
        isRegistering: false,
        isRegisterOTPSent: false,
        isOTPSent: false,
        isRequestOTPDone: false,
        showOTPSegment: false,
    };
}

export function registerUser(creds, callback = null) {
    return (dispatch) => {
        dispatch(requestingRegister());
        return eventCallApi('v1/auth/signup', 'POST', creds, false, true).then((res) => {
            if (res.data && res.data.isOTPSent && !res.data.userExists) {
                if (callback) {
                    callback();
                }
                userNotify(res.data.message, 'success');
                dispatch(registerSuccess());
            } else if (res.data) {
                userNotify(res.data.message, 'error');
                dispatch(registerFailure());
            } else {
                userNotify('Some error occurred', 'error');
                dispatch(registerFailure());
            }
        });
    };
}

export function setRegisterSuccessModal(val) {
    return {
        type: REGISTER_SUCCESS_MODAL,
        payload: val,
    };
}

export function showUserLocation(userCurrentCity) {
    return {
        type: ADDING_USER_LOCATION,
        userCurrentCity,
    };
}

export function reverseGeocoding(longitude, latitude) {
    return (dispatch) => {
        venueCallApi(`geoLocation/get-location-details`, 'post', {
            longitude,
            latitude,
        }).then((res) => {
            if (res.status === 'Success' && res?.data?.city[0]?._id != null) {
                dispatch(showUserLocation(res.data.city[0].name));
            } else {
                dispatch(showUserLocation('Not Found'));
            }
        });
    };
}
